import { render } from "./FollowList.vue?vue&type=template&id=ac2a3c18&scoped=true"
import script from "./FollowList.vue?vue&type=script&lang=js"
export * from "./FollowList.vue?vue&type=script&lang=js"

import "./FollowList.vue?vue&type=style&index=0&id=ac2a3c18&scoped=true&lang=less"

import exportComponent from "D:\\project\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac2a3c18"]])

export default __exports__